import { Component, inject, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { Table } from 'primeng/table';
import { environment } from '../../environment/environment';
import { ExportAvanzatoItemDto, ExportAvanzatoFilters, ExportAvanzatoListDto, FiltriAvanzatiExportDropdownDto, ExportAvanzatoEsportazioneDto } from '../../model/export-avanzato-data';
import { Provincia, Comune, Titolo, StatoIscritto, GruppoValore, CTU } from '../../model/iscritti-data';
import { CustomAutocompleteService } from '../../services/custom-autocomplete.service';
import { ExportAvanzatoService } from '../../services/export-avanzato.service';
import { RoleService } from '../../services/role.service';

@Component({
  selector: 'app-export-avanzato',
  templateUrl: './export-avanzato.component.html',
  styleUrl: './export-avanzato.component.scss'
})
export class ExportAvanzatoComponent {
  @ViewChild('dt') dt!: Table;

  // gestione della regione per i componenti
  labelRegionale = environment.labelRegionale;

  // services
  private route = inject(ActivatedRoute);
  private message_service = inject(MessageService);
  private export_service = inject(ExportAvanzatoService);
  public role_service = inject(RoleService);
  private custom_autocomplete = inject(CustomAutocompleteService);

  xlsSpinner: boolean = false;

  dettaglioIscrittoRoute = '/gestione_albo/gestione_iscritti/dettaglio_iscritto/';

  // filtro per gli stati dell'iscritto
  statiIscrittoDropdown: StatoIscritto[] = [];
  titoliDropdown: Titolo[] = [];
  provinceDropdown: Provincia[] = [];
  comuneDropdown: Comune[] = [];
  ctuDropdown: CTU[] = [];
  //tipoDeliberaDropdown: TipoDelibera[] = [];
  filteredComuni: Comune[] = [];

  showAdvancedFilters: boolean = false;
  showColumnSelect: boolean = false;
  numeroFiltriAvanzati: number = 0;
  sezioniDropdown: GruppoValore[] = [
    { nome: 'Sezione A', valore: 'A' },
    { nome: 'Sezione B', valore: 'B' }
  ];
  situazioniDropdown: GruppoValore[] = [
    { nome: 'REGOLARE', valore:'regolare' },
    { nome: 'IN ATTESA', valore:'inAttesa' },
    { nome: 'MOROSO', valore:'moroso' }
  ]
  operatorDropdown = ['AND', 'OR'];

  private readonly columns: GruppoValore[] = [
    { nome: 'Id', valore: 'id'},
    { nome: 'Codice Fiscale', valore: 'codiceFiscale'},
    { nome: 'Nome', valore: 'nome'},
    { nome: 'Cognome', valore: 'cognome'},
    { nome: 'Alias', valore: 'alias'},
    { nome: 'Sesso', valore: 'sesso'},
    { nome: 'Data Nascita', valore: 'dataNascita'},
    { nome: 'Luogo Nascita', valore: 'luogoNascita'},
    { nome: 'Provincia Nascita', valore: 'provinciaNascita'},
    { nome: 'Cittadinanza', valore: 'cittadinanza'},
    { nome: 'Email', valore: 'email'},
    { nome: 'Pec', valore: 'pec'},
    { nome: 'Telefono', valore: 'telefono'},
    { nome: 'Residenza Indirizzo', valore: 'residenzaIndirizzo'},
    { nome: 'Residenza Provincia', valore: 'residenzaProvincia'},
    { nome: 'Residenza Comune', valore: 'residenzaComune'},
    { nome: 'Residenza CAP', valore: 'residenzaCap'},
    { nome: 'Residenza Luogo', valore: 'residenzaLuogo'},
    { nome: 'Residenza Stato', valore: 'residenzaStato'},
    { nome: 'Domicilio Indirizzo', valore: 'domicilioIndirizzo'},
    { nome: 'Domicilio Provincia', valore: 'domicilioProvincia'},
    { nome: 'Domicilio Comune', valore: 'domicilioComune'},
    { nome: 'Domicilio CAP', valore: 'domicilioCap'},
    { nome: 'Domicilio Luogo', valore: 'domicilioLuogo'},
    { nome: 'Permesso Soggiorno', valore: 'permessoSoggiorno'},
    { nome: 'Scadenza Permesso Soggiorno', valore: 'scadenzaPermessoSoggiorno'},
    { nome: 'Permesso Soggiorno Illimitato', valore: 'permessoSoggiornoIllimitato'},
    { nome: 'Titolo', valore: 'titolo'},
    { nome: 'Università Laurea', valore: 'universitaLaurea'},
    { nome: 'Laurea Data', valore: 'laureaData'},
    { nome: 'Laurea Abilitante', valore: 'laureaAbilitante'},
    { nome: 'Tipo Abilitazione', valore: 'tipoAbilitazione'},
    { nome: 'Università Abilitazione', valore: 'universitaAbilitazione'},
    { nome: 'Abilitazione Data', valore: 'abilitazioneData'},
    { nome: 'Abilitato con Riserva', valore: 'riserva'},
    { nome: 'Neuropsicologo', valore: 'neuropsicologo'},
    { nome: 'Numero Protocollo Neuropsicologo', valore: 'protNpsNumero'},
    { nome: 'Data Protocollo Neuropsicologo', valore: 'protNpsData'},
    { nome: 'Psicoterapeuta', valore: 'psicoterapeuta'},
    { nome: 'Psicoterapeuta Articolo', valore: 'psicoterapeutaArticolo'},
    { nome: 'Psicoterapeuta Data', valore: 'psicoterapeutaData'},
    { nome: 'N° Iscrizione', valore: 'numeroIscrizione'},
    { nome: 'Data Iscrizione', valore: 'dataIscrizione'},
    { nome: 'Sezione', valore: 'sezioneAlbo'},
    { nome: 'Domanda Protocollo', valore: 'domandaProtocollo'},
    { nome: 'Domanda Data', valore: 'domandaData'},
    { nome: 'Stato', valore: 'stato'},
    { nome: 'Motivo Sospensione', valore: 'motivoSospensione'},
    { nome: 'Sospensione Dal', valore: 'sospensioneDal'},
    { nome: 'Sospensione Al', valore: 'sospensioneAl'},
    { nome: 'Procedimento Disciplinare In Corso', valore: 'procedimentoDisciplinareInCorso'},
    { nome: 'Radiato Data', valore: 'radiatoData'},
    { nome: 'Cancellato Data', valore: 'cancellatoData'},
    { nome: 'CTU', valore: 'ctu'},
    { nome: 'Perito', valore: 'perito'},
    { nome: 'Articolo 8.2', valore: 'articolo82'},
    { nome: 'Dipendente Pubblico', valore: 'dipendentePubblico'},
    { nome: 'Professore Presso Università', valore: 'professorePresso'},
    { nome: 'Professore Univeristario', valore: 'professoreUniversitario'},
    { nome: 'Trasferimento Da Ordine', valore: 'trasferimentoDa'},
    { nome: 'Data Trasferimento Entrata', valore: 'trasferimentoEntrataData'},
    { nome: 'Trasferimento A Ordine', valore: 'trasferimentoA'},
    { nome: 'Data Trasferimento Uscita', valore: 'trasferimentoUscitaData'}
  ];
  sourceColumns: GruppoValore[] = [...this.columns];
  targetColumns: GruppoValore[] = [];

  //impostazioni della tabella
  vociTabella: GruppoValore[] = [
    { nome: 'Codice Fiscale', valore: 'codiceFiscale' },
    { nome: 'Nome', valore: 'nome' },
    { nome: 'Cognome', valore: 'cognome' },
    { nome: 'Sezione', valore: 'sezioneAlbo' },
    { nome: 'N° Iscrizione', valore: 'numeroIscrizione' },
    { nome: 'Stato', valore: 'statoIscritto' },
    { nome: 'Situazione Contabile', valore: 'situazione' }
  ]
  listaIscritti: ExportAvanzatoItemDto[] = [];

  orderColumn: string = '';
  order: string = 'ASC';
  page: number = 0;
  pageSize: number = 25;
  first: number = 0;
  totaleDati: number = 0;

  //filtri form
  filtriForm: FormGroup|undefined;

  ngOnInit(){
    const filtriAvanzatiExportDropdown: FiltriAvanzatiExportDropdownDto = this.route.snapshot.data['dropdown'];
    this.statiIscrittoDropdown = filtriAvanzatiExportDropdown.statiIscritto;
    this.titoliDropdown = filtriAvanzatiExportDropdown.titoli;
    this.provinceDropdown = filtriAvanzatiExportDropdown.province;
    this.comuneDropdown = filtriAvanzatiExportDropdown.comuni;
    this.ctuDropdown = filtriAvanzatiExportDropdown.ctu;
    //this.tipoDeliberaDropdown = filtriAvanzatiExportDropdown.tipiDelibera;
    this.createForm();
  }

  createForm(){
    this.filtriForm = new FormGroup({
      inserimento: new FormControl<string|null>(null),
      stato: new FormControl<number[]|null>(null),
      statoOperator: new FormControl<string|null>('AND'),
      sezione: new FormControl<GruppoValore|null>(null),
      sezioneOperator: new FormControl<string|null>('AND'),
      titoli: new FormControl<number[]|null>(null),
      titoliOperator: new FormControl<string|null>('AND'),
      residenzaProvincia: new FormControl<string[]|null>(null),
      residenzaProvinciaOperator: new FormControl<string|null>('AND'),
      residenzaComune: new FormControl<Comune|null>(null),
      residenzaComuneOperator: new FormControl<string|null>('AND'),
      domicilioProvincia: new FormControl<string[]|null>(null),
      domicilioProvinciaOperator: new FormControl<string|null>('AND'),
      domicilioComune: new FormControl<Comune|null>(null),
      domicilioComuneOperator: new FormControl<string|null>('AND'),
      annoNascitaDal: new FormControl<number|null>(null),
      annoNascitaAl: new FormControl<number|null>(null),
      annoNascitaOperator: new FormControl<string|null>('AND'),
      dataIscrizioneDal: new FormControl<Date|null>(null),
      dataIscrizioneAl: new FormControl<Date|null>(null),
      dataIscrizioneOperator: new FormControl<string|null>('AND'),
      noPec: new FormControl<boolean|null>(null),
      noPecOperator: new FormControl<string|null>('AND'),
      permessoSoggiorno: new FormControl<boolean|null>(null),
      permessoSoggiornoOperator: new FormControl<string|null>('AND'),
      ctu: new FormControl<number[]|null>(null),
      ctuOperator: new FormControl<string|null>('AND'),
      perito: new FormControl<number[]|null>(null),
      peritoOperator: new FormControl<string|null>('AND'),
      situazione: new FormControl<string[]|null>(null),
      situazioneOperator: new FormControl<string|null>('AND'),
      annoMorositaDal: new FormControl<number|null>(null),
      annoMorositaAl: new FormControl<number|null>(null),
      annoMorositaOperator: new FormControl<string|null>('AND'),
      numeroAnniMorositaDal: new FormControl<number|null>(null),
      numeroAnniMorositaAl: new FormControl<number|null>(null),
      numeroAnniMorositaOperator: new FormControl<string|null>('AND'),
/*      numeroDelibera: new FormControl<number|null>(null),
      numeroDeliberaOperator: new FormControl<string|null>('AND'),
      tipoDelibera: new FormControl<GruppoValore|null>(null),
      tipoDeliberaOperator: new FormControl<string|null>('AND'),
      chiusa: new FormControl<boolean|null>(false),
      chiusaOperator: new FormControl<string|null>('AND'),
      finalizzata: new FormControl<boolean|null>(false),
      finalizzataOperator: new FormControl<string|null>('AND') */
    });
    this.filtriForm.valueChanges.subscribe(() => {
      this.page = 0;
      this.first = 0;
      this.loadData();
    })
  }

  private loadData(){
    const data: ExportAvanzatoFilters = this.getFilters();
    this.export_service.getIscrittiExport(data).subscribe({
      next: (result: ExportAvanzatoListDto) => {
        this.listaIscritti = result.lista;
        this.totaleDati = result.conteggio;
        this.numeroFiltriAvanzati = this.conteggioAvanzati();
      },
      error: () => {
        this.message_service.add({
          severity: 'error',
          summary: 'Qualcosa è andato storto',
          detail: 'Operazione interrotta.'
        });
      }
    })
  }

  getFilters(): ExportAvanzatoFilters{
    const formValue = this.filtriForm!.getRawValue();
    return {
      orderColumn: this.orderColumn,
      order: this.order,
      page: this.page,
      pageSize: this.pageSize,
      inserimento: formValue.inserimento,
      stato: formValue.stato,
      statoOperator: formValue.statoOperator,
      sezione: formValue.sezione ? formValue.sezione?.valore : null,
      sezioneOperator: formValue.sezioneOperator,
      titoli: formValue.titoli,
      titoliOperator: formValue.titoliOperator,
      residenzaProvincia: formValue.residenzaProvincia,
      residenzaProvinciaOperator: formValue.residenzaProvinciaOperator,
      residenzaComune: formValue.residenzaComune ? formValue.residenzaComune?.codice_catastale! : null,
      residenzaComuneOperator: formValue.residenzaComuneOperator,
      domicilioProvincia: formValue.domicilioProvincia,
      domicilioProvinciaOperator: formValue.domicilioProvinciaOperator,
      domicilioComune: formValue.domicilioComune ? formValue.domicilioComune?.codice_catastale! : null,
      domicilioComuneOperator: formValue.domicilioComuneOperator,
      annoNascitaDal: formValue.annoNascitaDal,
      annoNascitaAl: formValue.annoNascitaAl,
      annoNascitaOperator: formValue.annoNascitaOperator,
      dataIscrizioneDal: formValue.dataIscrizioneDal ? this.buildDate(formValue.dataIscrizioneDal) : null,
      dataIscrizioneAl: formValue.dataIscrizioneAl ? this.buildDate(formValue.dataIscrizioneAl) : null,
      dataIscrizioneOperator: formValue.dataIscrizioneOperator,
      noPec: formValue.noPec,
      noPecOperator: formValue.noPecOperator,
      permessoSoggiorno: formValue.permessoSoggiorno,
      permessoSoggiornoOperator: formValue.permessoSoggiornoOperator,
      ctu: formValue.ctu,
      ctuOperator: formValue.ctuOperator,
      perito: formValue.perito,
      peritoOperator: formValue.peritoOperator,
      situazione: formValue.situazione,
      situazioneOperator: formValue.situazioneOperator,
      annoMorositaDal: formValue.annoMorositaDal,
      annoMorositaAl: formValue.annoMorositaAl,
      annoMorositaOperator: formValue.annoMorositaOperator,
      numeroAnniMorositaDal: formValue.numeroAnniMorositaDal,
      numeroAnniMorositaAl: formValue.numeroAnniMorositaAl,
      numeroAnniMorositaOperator: formValue.numeroAnniMorositaOperator,
/*      numeroDelibera: formValue.numeroDelibera,
      numeroDeliberaOperator: formValue.numeroDeliberaOperator,
      tipoDelibera: formValue.tipoDelibera ? +formValue.tipoDelibera.valore : null,
      tipoDeliberaOperator: formValue.tipoDeliberaOperator,
      chiusa: formValue.chiusa,
      chiusaOperator: formValue.chiusaOperator,
      finalizzata: formValue.finalizzata,
      finalizzataOperator: formValue.finalizzataOperator */
    }
  }

  resetPagination(){
    this.orderColumn = 'codiceFiscale';
    this.order = 'ASC';
    this.page = 0;
    this.pageSize = 25;
    this.first = 0;
  }

  getSituazioneLabel(situazione: string){
    let label = '';
    if(situazione === 'regolare') return 'REGOLARE';
    if(situazione === 'inAttesa') return 'IN ATTESA';
    if(situazione === 'moroso') return 'MOROSO';
    return label;
  }
  coloreSituazione(situazione: string): string{
    let colore = '';
    if(situazione === 'regolare') colore = '#2EAB5B';
    if(situazione === 'inAttesa') colore = '#E5C130';
    if(situazione === 'moroso') colore = '#FF0000';
    return colore;
  }
  coloreStato(statoIscritto: string){
    let colore = '';
    if(statoIscritto === 'ATTIVO') return '#16A34A';
    if(statoIscritto === 'SOSPESO') return '#CDC103';
    if(statoIscritto === 'TRASFERIMENTO') return '#00BFFE';
    if(statoIscritto === 'CANCELLATO') return '#FBA465';
    if(statoIscritto === 'RADIATO') return '#EF5233';
    if(statoIscritto === 'PROVVISORIO') return '#BF08FF';
    return colore;
  }

  pageChange(event: any){
    this.page = event.page;
    this.pageSize = event.rows;
    this.first = event.first;
    this.loadData();
  }
  ordinamento(event: any){
    this.orderColumn = event.sortField ? event.sortField : 'codiceFiscale';
    this.order = event.sortOrder === 1 ? 'ASC' : 'DESC'; //-1 discendente / 1 ascendente
    this.page = 0;
    this.pageSize = 25;
    this.loadData();
  }
  orderCustom(order: string): number{
    let check = 0;
    if(order === 'ASC') check = 1;
    if(order === 'DESC') check = -1;
    return check;
  }
  resetBoxRicerca(){
    this.filtriForm!.get('inserimento')?.setValue('');
  }
  clearFilters(){
    this.resetPagination();
    this.resetFiltriForm();
    this.dt.reset();
    this.sourceColumns = [...this.columns];
    this.targetColumns = [];
    this.loadData();
  }

  resetFiltriForm(){
    this.filtriForm!.reset();
    this.filtriForm!.get('statoOperator')?.setValue('AND', { emitEvent: false });
    this.filtriForm!.get('sezioneOperator')?.setValue('AND', { emitEvent: false });
    this.filtriForm!.get('titoliOperator')?.setValue('AND', { emitEvent: false });
    this.filtriForm!.get('residenzaProvinciaOperator')?.setValue('AND', { emitEvent: false });
    this.filtriForm!.get('residenzaComuneOperator')?.setValue('AND', { emitEvent: false });
    this.filtriForm!.get('domicilioProvinciaOperator')?.setValue('AND', { emitEvent: false });
    this.filtriForm!.get('domicilioComuneOperator')?.setValue('AND', { emitEvent: false });
    this.filtriForm!.get('annoNascitaOperator')?.setValue('AND', { emitEvent: false });
    this.filtriForm!.get('dataIscrizioneOperator')?.setValue('AND', { emitEvent: false });
    this.filtriForm!.get('noPecOperator')?.setValue('AND', { emitEvent: false });
    this.filtriForm!.get('permessoSoggiornoOperator')?.setValue('AND', { emitEvent: false });
    this.filtriForm!.get('ctuOperator')?.setValue('AND', { emitEvent: false });
    this.filtriForm!.get('peritoOperator')?.setValue('AND', { emitEvent: false });
    this.filtriForm!.get('situazioneOperator')?.setValue('AND', { emitEvent: false });
    this.filtriForm!.get('annoMorositaOperator')?.setValue('AND', { emitEvent: false });
    this.filtriForm!.get('numeroAnniMorositaOperator')?.setValue('AND', { emitEvent: false });
/*    this.filtriForm!.get('numeroDeliberaOperator')?.setValue('AND', { emitEvent: false });
    this.filtriForm!.get('tipoDeliberaOperator')?.setValue('AND', { emitEvent: false });
    this.filtriForm!.get('chiusaOperator')?.setValue('AND', { emitEvent: false });
    this.filtriForm!.get('finalizzataOperator')?.setValue('AND', { emitEvent: false });
    this.filtriForm!.get('chiusa')?.setValue(false, { emitEvent: false });
    this.filtriForm!.get('finalizzata')?.setValue(false, { emitEvent: false }); */
  }

  //mostra/nascondi filtri avanzati
  showFilters(){
    this.showAdvancedFilters = !this.showAdvancedFilters;
  }
  showColumn(){
    this.showColumnSelect = !this.showColumnSelect;
  }
  //conta i filtri avanzati presenti
  conteggioAvanzati(): number{
    const values = this.filtriForm!.value;
    let conteggio = 0;
    if(values.stato && values.stato.length > 0) conteggio++;
    if(values.sezione) conteggio++;
    if(values.titoli && values.titoli.length > 0) conteggio++;
    if(values.residenzaProvincia && values.residenzaProvincia.length > 0) conteggio++;
    if(values.residenzaComune) conteggio++;
    if(values.domicilioProvincia && values.domicilioProvincia.length > 0) conteggio++;
    if(values.domicilioComune) conteggio++;
    if(values.annoNascitaDal || values.annoNascitaAl) conteggio++;
    if(values.dataIscrizioneDal || values.dataIscrizioneAl) conteggio++;
    if(values.noPec) conteggio++;
    if(values.permessoSoggiorno) conteggio++;
    if(values.ctu && values.ctu.length > 0) conteggio++;
    if(values.perito && values.perito.length > 0) conteggio++;
    if(values.situazione && values.situazione.length > 0) conteggio++;
    if(values.annoMorositaDal || values.annoMorositaAl) conteggio++;
    if(values.numeroAnniMorositaDal || values.numeroAnniMorositaAl) conteggio++;
    return conteggio;
  }
  //autocompletamento per i p-autocomplete
  filterAutoComplete(event: AutoCompleteCompleteEvent, tipo: string){
    const query = event.query.toLowerCase();
    const queryParts = query.split(" ");
    if(tipo === 'comuni')
      this.filteredComuni = this.custom_autocomplete.filterList(queryParts, this.comuneDropdown!);
  }

  printIscrittiXLS(){
    const filtri = this.getFilters();
    const colonne: string[] = this.targetColumns.map(item => item.valore);
    const data: ExportAvanzatoEsportazioneDto = {
      filtri: filtri,
      colonne: (colonne != null && colonne.length > 0) ? colonne : this.sourceColumns.map(item => item.valore)
    }

    this.xlsSpinner = true;

    this.export_service.esporta(data).subscribe({
      next: blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'iscritti_' + this.labelRegionale + '.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
  
        this.xlsSpinner = false;
      },
      error: err => {
        this.message_service.add({
          severity: 'error',
          summary: 'Qualcosa è andato storto',
          detail: 'Operazione interrotta.'
        });
        console.error('Error downloading the file', err);
        this.xlsSpinner = false;
      }
    });
  }

  buildDate(data_in: Date){
    const day = String(data_in.getDate()).padStart(2, '0');
    const month = String(data_in.getMonth() + 1).padStart(2, '0');
    const year = String(data_in.getFullYear());
    const data = `${year}-${month}-${day}`;
    return data;
  }
}
